// extracted by mini-css-extract-plugin
module.exports = {"searchContent":"pM","content":"pN","navigation":"pO","mainPanel":"pP","footer":"pQ"};